import React, { useEffect } from 'react'
import GHref from 'tennders-market/common/components/element/GHref'
import TextInput from 'tennders-common/form/components/new-inputs/TextInput'
import CurrencyInput from 'tennders-common/form/components/new-inputs/CurrencyInput'
import { FieldsetContainer, GInput } from 'tennders-common/form/components'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import TransactionSelectInput from 'tennders-finance/cost-invoice/components/TransactionSelectInput'
import useMultipleSalesInvoiceExtraCostRow
  from 'tennders-finance/sales-invoice/hooks/useMultipleSalesInvoiceExtraCostRow'
import PercentageInput from 'tennders-common/form/components/new-inputs/PercentageInput'
import OnlyInputContainer from 'tennders-common/form/components/new-inputs/OnlyInputContainer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

const targets = [
  {
    label: 'To all',
    value: 'to-all'
  },
  {
    label: 'Specific Transaction',
    value: 'specific-transaction'
  }
]

const MultipleSalesInvoiceExtraCostRow = ({
  index = 0,
  removeLine,
  onFormChange,
  initialErrors,
  companyId,
  keyIndex,
  reversedVat,
  defaultVat,
  isCreditNote
}) => {
  const { onChange, errors, form, transaction, onTransactionChange } = useMultipleSalesInvoiceExtraCostRow({ initialErrors, index })

  useEffect(() => {
    if (onFormChange) {
      onFormChange(index, form)
    }
  }, [onFormChange, index, form])

  useEffect(() => {
    // if (form.amount) {
    onChange('vatPercentage', defaultVat)
    // }
  }, [defaultVat])

  return (
    <tr>
      <td>
        <GHref
          className="cursor-pointer link-mid-gray"
          onClick={() => removeLine(keyIndex)}
        >
          <FontAwesomeIcon icon={faXmark} fontSize={20} />
        </GHref>
      </td>
      <td>
        {index + 1}
      </td>
      <td>
        <TransactionSelectInput
          withAll
          disabled={isCreditNote || !companyId}
          companyType="shipper"
          companyId={companyId}
          transactionId={form.transactionId}
          selectedOptionLabel={form?.orderNo}
          error={errors?.transactionId}
          onTransactionChange={onTransactionChange}
        />
      </td>
      <td>
        <TextInput
          className="form-input smaller"
          value={form.concept}
          error={errors.concept}
          onSet={(value) => onChange('concept', value)}
        />
      </td>
      <td>
        <CurrencyInput
          className="form-input smaller"
          placeholder="amount"
          allowNegativeValue={false}
          onSet={(value) => onChange('amount', value)}
          value={form.amount}
          error={errors.amount}
        />
      </td>
      <td>
        <OnlyInputContainer
          name="vatPercentage"
          form={form}
          onChange={onChange}
          errors={errors}
          renderInput={(rest) => (
            <PercentageInput
              className="form-input smaller"
              {...rest}
              value={form.vatPercentage || null}
            />
          )}
        />
      </td>
      <td>
        {GCurrency({ value: form.totalAmount || 0 })}
      </td>
    </tr>
  )
}

export default MultipleSalesInvoiceExtraCostRow
